import React from 'react'
import { TabsV2 } from 'containers/TempTabs/TempTabs'
import { WidgetDateFilter } from '../types'

export const DateFilters: React.FC<{
  onChange: (value: WidgetDateFilter) => void
  value?: WidgetDateFilter
}> = ({ onChange, value }) => {
  const onChangeHandler = (value: number) => {
    onChange(convertNumberToDate(value))
  }
  return (
    <TabsV2
      fullWidth
      style={{
        height: 'fit-content',
      }}
      onSelect={onChangeHandler}
      selectedIndex={convertDateToNumber(value)}
    >
      <TabsV2.TabButton>1D</TabsV2.TabButton>
      <TabsV2.TabButton>1W</TabsV2.TabButton>
      <TabsV2.TabButton>1M</TabsV2.TabButton>
      <TabsV2.TabButton>3M</TabsV2.TabButton>
      <TabsV2.TabButton>6M</TabsV2.TabButton>
      <TabsV2.TabButton>1Y</TabsV2.TabButton>
    </TabsV2>
  )
}

const convertNumberToDate = (value?: number) =>
  value === 0
    ? '1d'
    : value === 1
      ? '1w'
      : value === 2
        ? '1m'
        : value === 3
          ? '3m'
          : value === 4
            ? '6m'
            : '1y'

const convertDateToNumber = (value?: WidgetDateFilter) =>
  value === '1d'
    ? 0
    : value === '1w'
      ? 1
      : value === '1m'
        ? 2
        : value === '3m'
          ? 3
          : value === '6m'
            ? 4
            : 5
